import state from './modules/state.js';
import * as actions from './modules/actions/_index.js';
import * as mutations from './modules/mutations/_index.js';
import * as getters from './modules/getters.js';

const Signals = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};

export default Signals;